import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  enviarTokenRecuperacion,
  cambiarContrasena
} from '../services/recuperacionService';
import './Login.css';

export default function RecuperarContrasena() {
  const location = useLocation();
  const navigate = useNavigate();
  const correoDesdeLogin = location.state?.email || '';

  const [email, setEmail] = useState(correoDesdeLogin);
  const [token, setToken] = useState('');
  const [nuevaContrasena, setNuevaContrasena] = useState('');
  const [confirmarContrasena, setConfirmarContrasena] = useState('');
  const [tokenVerificado, setTokenVerificado] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [administradorAsignado, setAdministradorAsignado] = useState('');

  const handleEnviarToken = async () => {
    try {
      const respuesta = await enviarTokenRecuperacion(email);
      if (respuesta.tipoUsuario === 'Temporal') {
        setAdministradorAsignado(respuesta.nombreAdministrador);
        setMensaje('⚠️ Este correo pertenece a un usuario temporal. Comunícate con el administrador.');
        setTimeout(() => {
          setMensaje('🔄 Redirigiendo al login...');
          setTimeout(() => navigate('/', { state: { mostrarLogin: true } }), 1500);
        }, 2000);
      } else {
        setMensaje('✅ Token enviado al correo.');
      }
    } catch (error) {
      setMensaje(`❌ ${error.message}`);
    }
  };

  const handleVerificarToken = async () => {
    if (!token.trim()) return setMensaje('❌ Ingresa el token recibido.');
    setTokenVerificado(true);
    setMensaje('El token se validará al guardar la nueva contraseña.');
  };

  const handleCambiarContrasena = async () => {
    if (nuevaContrasena !== confirmarContrasena) {
      setMensaje('❌ Las contraseñas no coinciden.');
      return;
    }

    try {
      await cambiarContrasena(email, token, nuevaContrasena);
      setMensaje('✅ Contraseña cambiada correctamente. Ya puedes iniciar sesión.');
      setTimeout(() => {
        setMensaje('🔄 Redirigiendo al login...');
        setTimeout(() => {
          navigate('/', { state: { mostrarLogin: true } });
        }, 1500);
      }, 2000);
    } catch (error) {
      setMensaje(`❌ ${error.message}`);
    }
  };

  return (
    <div className="relative flex items-center justify-center min-h-[100dvh] bg-black text-white px-4">
      {/* Botón para ir al login (esquina superior derecha) */}
      <div className="absolute top-4 right-4">
        <button
          onClick={() => navigate('/', { state: { mostrarLogin: true } })}
          className="inline-flex items-center gap-2 bg-cyan-600 hover:bg-cyan-700 text-white px-4 py-2 rounded text-sm shadow"
          title="Ir al login"
        >
          {/* ícono */}
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
            <path d="M10 3a1 1 0 000 2h7v14h-7a1 1 0 100 2h8a1 1 0 001-1V4a1 1 0 00-1-1h-8zM5.707 7.293a1 1 0 10-1.414 1.414L6.586 11H1a1 1 0 100 2h5.586l-2.293 2.293a1 1 0 101.414 1.414l4-4a1 1 0 000-1.414l-4-4z" />
          </svg>
          Login
        </button>
      </div>

      {/* Contenedor del formulario */}
      <div className="bg-neutral-900/90 backdrop-blur p-4 sm:p-6 md:p-8 rounded-xl border border-cyan-500 w-full max-w-md">
        <h2 className="text-xl sm:text-2xl text-green-400 font-bold mb-3 sm:mb-4 text-center">
          PROYECTO ANALISIS DE SISTEMAS Y SISTEMAS OPERATIVOS II
        </h2>
        <h3 className="text-yellow-300 text-center mb-4 sm:mb-6 text-sm sm:text-base">
          CONTROL DE ASISTENCIA
        </h3>

        {/* Email */}
        <label className="block text-xs sm:text-sm mb-1">Correo electrónico:</label>
        <input
          type="email"
          value={email}
          disabled={!!correoDesdeLogin}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-2 sm:p-2.5 mb-3 sm:mb-4 border border-cyan-500 rounded text-black"
        />
        <button
          onClick={handleEnviarToken}
          className="w-full bg-blue-600 hover:bg-blue-700 p-2 sm:p-2.5 rounded text-white mb-3 sm:mb-4"
        >
          Enviar Token
        </button>

        {/* Aviso de administrador si es temporal */}
        {administradorAsignado && (
          <p className="text-yellow-400 text-xs sm:text-sm text-center mb-3 sm:mb-4">
            Este usuario es temporal. Contacta a: <strong>{administradorAsignado}</strong>
          </p>
        )}

        {/* Verificación de token */}
        {!tokenVerificado && (
          <>
            <label className="block text-xs sm:text-sm mb-1">Token recibido:</label>
            <input
              type="text"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              className="w-full p-2 sm:p-2.5 mb-3 sm:mb-4 border border-cyan-500 rounded text-black"
            />
            <button
              onClick={handleVerificarToken}
              className="w-full bg-green-600 hover:bg-green-700 p-2 sm:p-2.5 rounded text-white mb-3 sm:mb-4"
            >
              Verificar Token
            </button>
          </>
        )}

        {/* Cambio de contraseña */}
        {tokenVerificado && (
          <>
            <label className="block text-xs sm:text-sm mb-1">Nueva contraseña:</label>
            <input
              type="password"
              value={nuevaContrasena}
              onChange={(e) => setNuevaContrasena(e.target.value)}
              className="w-full p-2 sm:p-2.5 mb-2 sm:mb-3 border border-cyan-500 rounded text-black"
            />

            <label className="block text-xs sm:text-sm mb-1">Confirmar contraseña:</label>
            <input
              type="password"
              value={confirmarContrasena}
              onChange={(e) => setConfirmarContrasena(e.target.value)}
              className="w-full p-2 sm:p-2.5 mb-3 sm:mb-4 border border-cyan-500 rounded text-black"
            />

            <button
              onClick={handleCambiarContrasena}
              className="w-full bg-cyan-600 hover:bg-cyan-700 p-2 sm:p-2.5 rounded text-white"
            >
              Cambiar Contraseña
            </button>
          </>
        )}

        {/* Mensajes */}
        {mensaje && (
          <p
            className={`auth-notice ${
              mensaje.startsWith('✅')
                ? 'auth-notice--success'
                : mensaje.startsWith('🔄')
                  ? 'auth-notice--info'
                  : 'auth-notice--error'
            }`}
            role="status"
            aria-live="polite"
          >
            {mensaje}
          </p>
        )}
      </div>
    </div>
  );
}
